import { useUser } from '../redux/reducer/user';
import { useContent } from '../redux/reducer/content';
import { useEffect } from 'react';
import { useRequestsHandlerData } from './useRequestsHandlerData';
import useServiceData from './useServiceData';

const openSomeRoom = {
  system_name: undefined, //сюда можно указать sys name комнаты
  serviceDataKey: undefined, //сюда ключ, по которому изменение комнаты будет зафиксировано в сервисные данные
};

export const useForceRoomSelection = ({ callbacks }) => {
  const { eventRooms } = useContent();
  const {
    profile: { eventRoomId },
  } = useUser();
  const { get, save } = useServiceData();

  const isPending = useRequestsHandlerData([
    { address: 'requestsUserSetActiveRoom' },
    { address: 'requestsUserServiceDataSave' },
  ]);

  useEffect(() => {
    const truthTypes = ['object', 'number'];

    if (!eventRooms || !truthTypes.includes(typeof eventRoomId)) return;

    const { system_name, serviceDataKey } = openSomeRoom;

    const modalsData = get('modalsData') ?? {};

    if (modalsData[serviceDataKey]) return;

    if (![system_name, serviceDataKey].every((value) => typeof value === 'string')) return;

    const { id } = eventRooms?.find(({ system_name: roomName }) => roomName === system_name) ?? {};

    if (truthTypes.includes(typeof id)) {
      callbacks.setActiveRoom(id);
      save('modalsData', { ...modalsData, [serviceDataKey]: true });
    }
  }, [eventRooms, eventRoomId]);

  useEffect(() => {
    const truthTypes = ['object', 'number'];

    if (!eventRooms || !truthTypes.includes(typeof eventRoomId)) return;

    const isHaveYourRoom = eventRooms?.some(({ id }) => id === eventRoomId);

    if (!isHaveYourRoom) {
      const originRoom = eventRooms?.find(({ system_name }) => system_name === 'origin')?.id;
      callbacks.setActiveRoom(originRoom);
    }
  }, [eventRooms, eventRoomId]);

  return { isPending };
};
